import React from 'react';
// 引入 Ant Design 的 Modal 组件和样式
import { Modal } from 'antd';
import { ErrorContext } from "../contexts/error";

type Props = {
  onClose: () => void;
};

const Errors: React.FC<Props> = ({ onClose }) => {
  const { errors } = React.useContext(ErrorContext);
  const [modalOpen, setModalOpen] = React.useState(true);

  const handleModalClose = () => {
    setModalOpen(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      open={modalOpen}
      onCancel={handleModalClose}
      footer={null}
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ margin: 0 }}>Errors</h2>
          <a
            className="button button--primary"
            href="https://www.igoiup.com/support.html"
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: '1.1em' }}
          >
            Visit support
          </a>
        </div>
      }
      width={600}
      style={{ top: 20 }}
    >
      <div className="Settings">
        {errors.map((error, index) => (
          <div key={index} className="Widget">
            {error.message}
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default Errors;